/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import Toolbar from 'loracoms/Toolbar';
import SearchInput from 'loracoms/SearchInput';
import appActions from 'loraactions/app';
import usageActions from 'loraactions/usage';
import IntlMsg from 'lorautils/intl/IntlMsg';
import AppOOQModal from './coms/AppOOQModal';
import AddAppModal from './coms/AddAppModal';
import ApplicationList from './coms/ApplicationList';
import styles from './styles/main.scss';


const propTypes = {
  intl: React.PropTypes.object.isRequired,
  getApps: React.PropTypes.func.isRequired,
  getAppsUsage: React.PropTypes.func.isRequired,
  orgBasic: React.PropTypes.object.isRequired,
  usage: React.PropTypes.object.isRequired,
};

class Application extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      appList: [],
      count: '',
      search: '',
      status: 'idle',
      mark: '',
      more: false,
      orgBasic: props.orgBasic,
      usage: props.usage,
    };
    this.handleAddApp = this.handleAddApp.bind(this);
    this.handleAdded = this.handleAdded.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'application');
  }

  componentWillReceiveProps(nextProps) {
    const { orgBasic, usage } = nextProps;
    if (orgBasic !== this.props.orgBasic) {
      this.setState({ orgBasic });
    }
    if (usage !== this.props.usage) {
      this.setState({ usage });
    }
  }

  handleAddApp() {
    const { orgBasic, usage } = this.state;
    if (orgBasic.status !== 'success' || usage.pendings.includes('apps')) {
      return;
    }

    if (usage.apps >= orgBasic.data.lrappnum) {
      this.setState({ showOOQ: true });
    } else {
      this.setState({ showAdd: true });
    }
  }

  handleAdded() {
    this.setState({ showAdd: false });
    const { getAppsUsage, getApps } = this.props;
    getAppsUsage();
    getApps({ count: true, tkcnt: true });
  }

  render() {
    const {
      searching = false,
      search = '',
      showOOQ = false,
      showAdd = false,
    } = this.state;

    const brandTools = [{
      type: 'buttons',
      buttons: [(
        <Button bsStyle="aisz-success" onClick={this.handleAddApp}>
          {this.intlMsg.msg('addapp.btn')}
          {' '}
          <span className="glyphicon glyphicon-plus" aria-hidden="true" />
        </Button>
      )],
    }];
    const rightTools = [{
      type: 'search',
      searchInput: (
        <SearchInput
          autoFocus
          placeholder={this.intlMsg.msg('app.search.placeholder')}
          value={search}
          onChange={e => this.setState({ search: e.target.value })}
          onFocus={() => this.setState({ searching: true })}
          onBlur={() => this.setState({ searching: false })}
        />
      ),
    }];

    return (
      <div className={styles.wrapper} style={{ minHeight: window.innerHeight - 50 }}>
        <div>
          <Toolbar
            brandIcon={<span className="halflings halflings-menu-hamburger" />}
            leftTools={brandTools}
            rightTools={rightTools}
          />
        </div>
        <ApplicationList searching={searching} searchText={search} />
        <div>
          <AddAppModal
            show={showAdd}
            onHide={() => this.setState({ showAdd: false })}
            onAdded={this.handleAdded}
            onOOQ={() => this.setState({ showAdd: false, showOOQ: true })}
          />
          <AppOOQModal
            show={showOOQ}
            onHide={() => this.setState({ showOOQ: false })}
          />
        </div>
      </div>
    );
  }
}

Application.propTypes = propTypes;

const mapStateToProps = state => ({
  orgBasic: state.org.basic,
  usage: state.usage,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getApps: appActions.getApps,
  getAppsUsage: usageActions.apps,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Application));




// WEBPACK FOOTER //
// ./src/containers/Application/index.jsx